import { appColors } from '@backrs_ui/common-ui';

import { Box, Button, Typography, SxProps, Theme } from '@mui/material';

type EnterButtonProps = Readonly<{
  onClick: () => void;
  label: string;
  showEnterHint?: boolean;
  disabled?: boolean;
}>;

export const EnterButton = ({
  onClick,
  label,
  showEnterHint = false,
  disabled = false,
}: EnterButtonProps) => {
  return (
    <Box sx={buttonContainerStyle}>
      <Button onClick={onClick} sx={buttonStyle} disabled={disabled}>
        {label}
      </Button>
      {showEnterHint && (
        <Typography sx={hintStyle}>
          press <strong>Enter ⏎</strong>
        </Typography>
      )}
    </Box>
  );
};

const buttonContainerStyle: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
};

const buttonStyle: SxProps<Theme> = {
  borderRadius: '20px',
  padding: '2px 15px',
  backgroundColor: appColors.color.blue1,
  color: '#FFFFFF',
  textTransform: 'none',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: appColors.color.blue2,
  },
  '&:disabled': {
    backgroundColor: appColors.color.blue3,
    color: '#FFFFFF',
  },
};

const hintStyle: SxProps<Theme> = {
  fontSize: '8pt',
  color: '#666666',
  ml: 1,
};
